var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer",staticStyle:{"position":"absolute !important"}},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"}),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"text-sm-end d-none d-sm-block"},[_vm._v(" クロスメッド株式会社、東京都板橋区坂下二丁目22番16号ー１０１号 ")])])])])])
}]

export { render, staticRenderFns }